/** Google Drive inbox folder config for n8n Refresh listings. Stored in app_settings.n8n_listings_folders */

export type ListingsIngestType = 'accessibility' | 'streaming'

export type ListingsStream = 'bbc' | 'itv' | 'c4' | 'amazon'

export interface ListingsFolderEntry {
  key: string
  label: string
  stream: ListingsStream
  ingest_type: ListingsIngestType
  drive_folder_id: string
  enabled: boolean
  accessibility_type?: 'ad' | 'subtitles' | 'bsl'
  service?: string
  window_days?: number
}

export const APP_SETTINGS_N8N_LISTINGS_FOLDERS_KEY = 'n8n_listings_folders'
export const APP_SETTINGS_N8N_PROCESSED_FOLDER_KEY = 'n8n_listings_processed_folder_id'
export const APP_SETTINGS_LISTINGS_MANAGEMENT_V2_KEY = 'listings_management_v2_enabled'

export function parseListingsFoldersJson(raw: string | null | undefined): ListingsFolderEntry[] {
  if (!raw?.trim()) return []
  try {
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter(isListingsFolderEntry)
  } catch {
    return []
  }
}

function isListingsFolderEntry(value: unknown): value is ListingsFolderEntry {
  if (!value || typeof value !== 'object') return false
  const o = value as Record<string, unknown>
  return (
    typeof o.key === 'string' &&
    typeof o.label === 'string' &&
    typeof o.stream === 'string' &&
    typeof o.ingest_type === 'string' &&
    typeof o.drive_folder_id === 'string' &&
    typeof o.enabled === 'boolean'
  )
}

export function serializeListingsFolders(folders: ListingsFolderEntry[]): string {
  return JSON.stringify(folders, null, 2)
}
